export default __webpack_public_path__ + "static/media/favicon.a6007217.ico";